import React from "react";
import BoxedLayout from "../../parts/layout/BoxedLayout";
import AccountForm from "../../components/account/AccountForm";

export default function AccountDetails() {

    return(
        <BoxedLayout content=
        {
            <>
            <h1 className="text-left">Account Details</h1>
            <AccountForm/>
            </>
        }/>
    )

}